import { FC } from "react";
import { Box, Button } from "@chakra-ui/react";

interface EvalRunListHeaderProps {
  onRunEvaluation: () => void;
}

const EvalRunListHeader: FC<EvalRunListHeaderProps> = ({ onRunEvaluation }) => {
  return (
    <Box w="100%" display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center" minWidth="250px">
        <Box mr="12px" textStyle="title">
          Evaluations
        </Box>
      </Box>
      <Button variant="primary" w="176px" h="48px" onClick={onRunEvaluation}>
        Run Evaluation
      </Button>
    </Box>
  );
};

export default EvalRunListHeader;
